import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';
import '../css/govuk-frontend.min.css';
import '../css/style.css';

function Privacy() {
  const { language } = useContext(LanguageContext);

  const text = {
    en: {
      title: "Privacy Policy",
      intro: "This page explains how your personal information is collected, used, and protected when you apply for funding or support through the Indigenous Skills and Employment Training (ISET) program.",
      informationWeCollect: "Information we collect",
      informationWeCollectContent: "We collect the information you provide during the ISET application process, such as your name, contact information, self-identified Indigenous identity, Social Insurance Number (SIN), education and employment information, and supporting documents.",
      informationWeCollectDetail: "Some questions may feel personal. We ask for this information only when it is needed to review eligibility, deliver services, arrange funding, or meet legal and reporting obligations.",
      howWeUseYourInformation: "How we use your information",
      howWeUseYourInformationContent: "Your information is used to review your ISET application, determine eligibility, deliver program services, and meet the legal and reporting requirements of Employment and Social Development Canada (ESDC).",
      howWeUseYourInformationDetail: "Your information is collected by the Native Women’s Association of Canada (NWAC) and may be accessed by authorized delivery partners that need it for these purposes. We do not use or share your information for unrelated purposes without your consent unless required by law.",
      dataProtectionAndSecurity: "Data protection and security",
      dataProtectionAndSecurityContent: "We protect your information using safeguards such as encryption, access controls, monitoring, and secure storage. Access is limited to authorized NWAC staff and authorized delivery partners with a program need to know.",
      indigenousData: "We respect Indigenous data sovereignty and governance. ISET information is handled within Canadian jurisdictions and under NWAC governance arrangements.",
      yourRights: "Your rights",
      yourRightsContent: "You can request access to, correction of, or deletion of your personal information, subject to legal requirements. If you want to ask why information is requested or discuss privacy rights for your application, sign in and use secure",
      changesToThisPolicy: "Changes to this policy",
      changesToThisPolicyContent: "We may update this privacy policy to reflect changes in our practices or legal requirements. Please review this page periodically for updates.",
      lastUpdated: "Last updated: March 16, 2026",
      messagesLink: "Messages"
    },
    fr: {
      title: "Politique de confidentialité",
      intro: "Cette page explique comment vos renseignements personnels sont recueillis, utilisés et protégés lorsque vous demandez un financement ou un soutien dans le cadre du programme ISET.",
      informationWeCollect: "Renseignements que nous recueillons",
      informationWeCollectContent: "Nous recueillons les renseignements que vous fournissez durant le processus de demande ISET, notamment votre nom, vos coordonnées, votre identité autochtone autodéclarée, votre numéro d’assurance sociale (NAS), vos renseignements scolaires et professionnels, ainsi que vos documents justificatifs.",
      informationWeCollectDetail: "Certaines questions peuvent sembler personnelles. Nous demandons ces renseignements seulement lorsqu’ils sont nécessaires pour évaluer l’admissibilité, offrir des services, attribuer du financement ou respecter des obligations légales et de reddition de comptes.",
      howWeUseYourInformation: "Comment nous utilisons vos renseignements",
      howWeUseYourInformationContent: "Vos renseignements servent à examiner votre demande ISET, à déterminer votre admissibilité, à offrir les services du programme et à respecter les obligations légales et de reddition de comptes auprès d’Emploi et Développement social Canada (EDSC).",
      howWeUseYourInformationDetail: "Vos renseignements sont recueillis par l’Association des femmes autochtones du Canada (AFAC) et peuvent être consultés par des partenaires de prestation autorisés qui en ont besoin à ces fins. Nous n’utilisons ni ne communiquons vos renseignements à des fins non liées au programme sans votre consentement, sauf si la loi l’exige.",
      dataProtectionAndSecurity: "Protection et sécurité des données",
      dataProtectionAndSecurityContent: "Nous protégeons vos renseignements à l’aide de mesures comme le chiffrement, les contrôles d’accès, la surveillance et le stockage sécurisé. L’accès est limité au personnel autorisé de l’AFAC et aux partenaires de prestation autorisés qui ont besoin de ces renseignements pour le programme.",
      indigenousData: "Nous respectons la souveraineté et la gouvernance des données autochtones. Les renseignements ISET sont traités au Canada selon les modalités de gouvernance de l’AFAC.",
      yourRights: "Vos droits",
      yourRightsContent: "Vous pouvez demander l’accès à vos renseignements personnels, leur correction ou leur suppression, sous réserve des exigences légales. Si vous souhaitez savoir pourquoi un renseignement est demandé ou discuter des droits liés à votre demande, ouvrez une session et utilisez les",
      changesToThisPolicy: "Modifications de cette politique",
      changesToThisPolicyContent: "Nous pouvons mettre à jour la présente politique de confidentialité pour refléter les changements apportés à nos pratiques ou aux exigences légales. Veuillez consulter cette page régulièrement pour prendre connaissance des mises à jour.",
      lastUpdated: "Dernière mise à jour : 16 mars 2026",
      messagesLink: "Messages sécurisés"
    }
  };
  return (
    <div>
      <main className="govuk-main-wrapper govuk-width-container" role="main">
        <h1 className="govuk-heading-l">{text[language].title}</h1>
        <p className="govuk-body">
          {text[language].intro}
        </p>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].informationWeCollect}</h2>
          <p className="govuk-body">
            {text[language].informationWeCollectContent}
          </p>
          <p className="govuk-body">
            {text[language].informationWeCollectDetail}
          </p>
        </section>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].howWeUseYourInformation}</h2>
          <p className="govuk-body">
            {text[language].howWeUseYourInformationContent}
          </p>
          <p className="govuk-body">
            {text[language].howWeUseYourInformationDetail}
          </p>
          <p className="govuk-body">
            {text[language].indigenousData}
          </p>
        </section>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].dataProtectionAndSecurity}</h2>
          <p className="govuk-body">
            {text[language].dataProtectionAndSecurityContent}
          </p>
        </section>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].yourRights}</h2>
          <p className="govuk-body">
            {text[language].yourRightsContent} <Link to="/messages/new" className="govuk-link">{text[language].messagesLink}</Link>.
          </p>
        </section>

        <section className="govuk-section-break govuk-section-break--xl govuk-section-break--visible">
          <h2 className="govuk-heading-m">{text[language].changesToThisPolicy}</h2>
          <p className="govuk-body">
            {text[language].changesToThisPolicyContent}
          </p>
        </section>

        <p className="govuk-body">
          {text[language].lastUpdated}
        </p>
      </main>
    </div>
  );
}

export default Privacy;


